module.exports = __webpack_public_path__ + "img/csv.45719c81.svg";